import {bytesToBase64} from './bytes-to-base64';
import {CIPHER_PREFIX, IV_LENGTH} from './cipher-format';

export const encrypt = async (payload: unknown, key: CryptoKey) => {
    const iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH));
    const plaintext = new TextEncoder().encode(JSON.stringify(payload));
    const ciphertext = new Uint8Array(await crypto.subtle.encrypt({name: 'AES-GCM', iv}, key, plaintext));

    const bytes = new Uint8Array(IV_LENGTH + ciphertext.length);
    bytes.set(iv);
    bytes.set(ciphertext, IV_LENGTH);
    return `${CIPHER_PREFIX}${bytesToBase64(bytes)}`;
};
